import axios from "axios";

const api_key = "194d8a67379374e13e12c99420c19098";
const API = axios.create({
  baseURL: `https://api.themoviedb.org/3`,
});

export default {
  movie(type) {
    return API.get(`movie/${type}?api_key=${api_key}&language=en-US`);
  },
  genres() {
    return API.get(`genre/movie/list?api_key=${api_key}&language=en-US`);
  },
  getMovieDetails(movieId) {
    return API.get(
      `movie/${movieId}?api_key=${api_key}&language=en-US&append_to_response=credits,videos,images`
    );
  },
};
